import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

type CalloutProps = {
  title: string
  description: string
  actionLabel?: string
  onActionClick?: () => void
  icon?: React.ReactNode
}

const Callout = ({ title, description, actionLabel, onActionClick, icon }: CalloutProps) => {
  return (
    <Card className="bg-darkBlue-700 border-none text-neutral-50 shadow-none hover:bg-darkBlue-800 rounded-br-xl rounded-bl-none rounded-t-none ">
      <CardContent className="flex items-center gap-4 px-6 py-8">
        {icon && <div className="flex h-10 w-10 shrink-0 items-center justify-center ">{icon}</div>}

        <div className="flex flex-1 flex-col gap-1">
          <p className="text-sm font-semibold">{title}</p>
          <p className="text-xs  text-neutral-50">{description}</p>
        </div>

        {actionLabel && (
          <Button size="sm" variant="default" className="shrink-0" onClick={onActionClick}>
            {actionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

export default Callout
